import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ayghecpkuraluinlttep.supabase.co';
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF5Z2hlY3BrdXJhbHVpbmx0dGVwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI2OTcxNzEsImV4cCI6MjA2ODI3MzE3MX0.HKlc9uSTDIkwKRE0LJelBi10seqmf2ia8s7cyH6JZGw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export async function uploadProductImage(file) {
  const fileExt = file.name.split('.').pop();
  const fileName = `product-${Date.now()}.${fileExt}`;
  const { data, error } = await supabase.storage.from('jowey').upload(fileName, file);
  if (error) throw error;
  return supabase.storage.from('jowey').getPublicUrl(data.path).data.publicUrl;
}
